/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TransactionsImport } from './routes/transactions'
import { Route as OtpImport } from './routes/otp'
import { Route as LoginImport } from './routes/login'
import { Route as InvestImport } from './routes/invest'
import { Route as HomeImport } from './routes/home'
import { Route as ErrorImport } from './routes/error'
import { Route as IndexImport } from './routes/index'
import { Route as TransactionsIndexImport } from './routes/transactions.index'
import { Route as TransactionsIdImport } from './routes/transactions.$id'

// Create/Update Routes

const TransactionsRoute = TransactionsImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRoute,
} as any)

const OtpRoute = OtpImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const InvestRoute = InvestImport.update({
  id: '/invest',
  path: '/invest',
  getParentRoute: () => rootRoute,
} as any)

const HomeRoute = HomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRoute,
} as any)

const ErrorRoute = ErrorImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const TransactionsIndexRoute = TransactionsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TransactionsRoute,
} as any)

const TransactionsIdRoute = TransactionsIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TransactionsRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorImport
      parentRoute: typeof rootRoute
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeImport
      parentRoute: typeof rootRoute
    }
    '/invest': {
      id: '/invest'
      path: '/invest'
      fullPath: '/invest'
      preLoaderRoute: typeof InvestImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/otp': {
      id: '/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof OtpImport
      parentRoute: typeof rootRoute
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsImport
      parentRoute: typeof rootRoute
    }
    '/transactions/$id': {
      id: '/transactions/$id'
      path: '/$id'
      fullPath: '/transactions/$id'
      preLoaderRoute: typeof TransactionsIdImport
      parentRoute: typeof TransactionsImport
    }
    '/transactions/': {
      id: '/transactions/'
      path: '/'
      fullPath: '/transactions/'
      preLoaderRoute: typeof TransactionsIndexImport
      parentRoute: typeof TransactionsImport
    }
  }
}

// Create and export the route tree

interface TransactionsRouteChildren {
  TransactionsIdRoute: typeof TransactionsIdRoute
  TransactionsIndexRoute: typeof TransactionsIndexRoute
}

const TransactionsRouteChildren: TransactionsRouteChildren = {
  TransactionsIdRoute: TransactionsIdRoute,
  TransactionsIndexRoute: TransactionsIndexRoute,
}

const TransactionsRouteWithChildren = TransactionsRoute._addFileChildren(
  TransactionsRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/home': typeof HomeRoute
  '/invest': typeof InvestRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/transactions': typeof TransactionsRouteWithChildren
  '/transactions/$id': typeof TransactionsIdRoute
  '/transactions/': typeof TransactionsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/home': typeof HomeRoute
  '/invest': typeof InvestRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/transactions/$id': typeof TransactionsIdRoute
  '/transactions': typeof TransactionsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/home': typeof HomeRoute
  '/invest': typeof InvestRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/transactions': typeof TransactionsRouteWithChildren
  '/transactions/$id': typeof TransactionsIdRoute
  '/transactions/': typeof TransactionsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/home'
    | '/invest'
    | '/login'
    | '/otp'
    | '/transactions'
    | '/transactions/$id'
    | '/transactions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/home'
    | '/invest'
    | '/login'
    | '/otp'
    | '/transactions/$id'
    | '/transactions'
  id:
    | '__root__'
    | '/'
    | '/error'
    | '/home'
    | '/invest'
    | '/login'
    | '/otp'
    | '/transactions'
    | '/transactions/$id'
    | '/transactions/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ErrorRoute: typeof ErrorRoute
  HomeRoute: typeof HomeRoute
  InvestRoute: typeof InvestRoute
  LoginRoute: typeof LoginRoute
  OtpRoute: typeof OtpRoute
  TransactionsRoute: typeof TransactionsRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ErrorRoute: ErrorRoute,
  HomeRoute: HomeRoute,
  InvestRoute: InvestRoute,
  LoginRoute: LoginRoute,
  OtpRoute: OtpRoute,
  TransactionsRoute: TransactionsRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/error",
        "/home",
        "/invest",
        "/login",
        "/otp",
        "/transactions"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/error": {
      "filePath": "error.tsx"
    },
    "/home": {
      "filePath": "home.tsx"
    },
    "/invest": {
      "filePath": "invest.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/otp": {
      "filePath": "otp.tsx"
    },
    "/transactions": {
      "filePath": "transactions.tsx",
      "children": [
        "/transactions/$id",
        "/transactions/"
      ]
    },
    "/transactions/$id": {
      "filePath": "transactions.$id.tsx",
      "parent": "/transactions"
    },
    "/transactions/": {
      "filePath": "transactions.index.tsx",
      "parent": "/transactions"
    }
  }
}
ROUTE_MANIFEST_END */
